import { render, staticRenderFns } from "./create-group.vue?vue&type=template&id=3b0b1f7e&scoped=true&"
import script from "./create-group.vue?vue&type=script&lang=js&"
export * from "./create-group.vue?vue&type=script&lang=js&"
import style0 from "./create-group.vue?vue&type=style&index=0&id=3b0b1f7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0b1f7e",
  null
  
)

export default component.exports